import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService } from '../shared/services/confirmation/confirmation.service';
import { ResponseService } from '../shared/services/response/response.service';
import { LdcOptionsPipe, AvailableProgramOptionsPipe, EnabledFeaturesPipe, TransactionTypePipe } from '../shared/ldcOptionsPipe';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCardModule} from '@angular/material/card';
import { CustomerService } from '../shared/services/customer/customer.service';
import { SharedModule } from '../shared/shared.module';
import { LocaleModule } from './templates/Locale/locale.module';
import { OptService } from './services/opt/opt.service';
import { CancelConfirmationComponent } from './templates/cancel-confirmation/cancel-confirmation.component';
import { PromptComponent } from '../shared/templates/prompt/prompt.component';


@NgModule({
    imports: [
        CommonModule,
        MatTabsModule,
        MatCardModule,
        SharedModule,
        LocaleModule,
        LdcOptionsPipe,
        AvailableProgramOptionsPipe,
        EnabledFeaturesPipe,
        TransactionTypePipe,
        CancelConfirmationComponent,
        PromptComponent
    ],
    providers: [
        ResponseService,
        ConfirmationService,
        CustomerService,
        OptService
    ],
    exports: [
        LdcOptionsPipe,
        CancelConfirmationComponent,
        AvailableProgramOptionsPipe,
        EnabledFeaturesPipe,
        TransactionTypePipe,
        MatTabsModule,
        MatCardModule,
        PromptComponent
    ]
})
export class OptSharedModule { }
